import { ProductsApi, useAPIQuery } from "melco-shared-logic";

export const useAllProducts = () => {
  return useAPIQuery(ProductsApi, ["allProducts"], async (api) => {
    const response = await api.productsGetList({});

    return response.list ?? [];
  });
};
